var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOwnerLessor = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5.25,10.53 C 5.25,9.9 4.75,9.4 4.12,9.4 C 3.5,9.4 3,9.9 3,10.53 L 3,12.1 L 3,13.9 L 3,16.75 C 3,17.47 3.28,18.16 3.79,18.66 L 6.6,21.47 C 6.94,21.81 7.39,22 7.87,22 L 9.75,22 C 10.49,22 11.1,21.4 11.1,20.65 L 11.1,18.43 C 11.1,17.6 10.77,16.79 10.18,16.2 L 9.46,15.49 L 9.46,15.49 L 9.04,15.06 L 8.14,14.16 C 7.79,13.81 7.21,13.81 6.86,14.16 C 6.51,14.52 6.51,15.09 6.86,15.44 L 7.76,16.34 L 8.19,16.77 C 8.5,17.08 8.45,17.59 8.09,17.83 C 7.81,18.01 7.45,17.98 7.21,17.74 L 5.77,16.31 C 5.44,15.97 5.25,15.51 5.25,15.03 L 5.25,13.9 L 5.25,11.65 L 5.25,10.53 M 18.75,10.53 L 18.75,11.65 L 18.75,13.9 L 18.75,15.03 C 18.75,15.51 18.56,15.97 18.22,16.31 L 16.79,17.74 C 16.55,17.98 16.19,18.01 15.91,17.83 C 15.55,17.59 15.5,17.07 15.81,16.77 L 16.24,16.34 L 17.14,15.44 C 17.49,15.09 17.49,14.52 17.14,14.16 C 16.79,13.81 16.21,13.81 15.86,14.16 L 14.96,15.06 L 14.54,15.49 L 14.54,15.49 L 13.82,16.2 C 13.23,16.79 12.9,17.6 12.9,18.43 L 12.9,20.65 C 12.9,21.4 13.51,22 14.25,22 L 16.13,22 C 16.61,22 17.06,21.81 17.4,21.47 L 20.21,18.66 C 20.72,18.16 21,17.47 21,16.75 L 21,13.9 L 21,12.1 L 21,10.53 C 21,9.9 20.5,9.4 19.88,9.4 C 19.25,9.4 18.75,9.9 18.75,10.53 L 18.75,10.53",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 12,2 C 12.5,2 12.85,2.5 12.85,3.15 L 12.85,5.25 L 16,7.05 L 16,8.05 L 12.85,7.15 L 12.85,8.95 L 13.85,9.75 L 13.85,10.6 L 12,10.1 L 10.15,10.6 L 10.15,9.75 L 11.15,8.95 L 11.15,7.15 L 8,8.05 L 8,7.05 L 11.15,5.25 L 11.15,3.15 C 11.15,2.5 11.5,2 12,2 L 12,2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOwnerLessor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/owner-lessor.f8f1ea61.svg";
export { ForwardRef as ReactComponent };